import '../../../../../navigation/menu/Menu.css';
import './DataTableDownloadData.css';
export var downloadMenuItem = '_1gjma320-3-5-0';
export var downloadMenuSuffix = '_1gjma321-3-5-0';